export const LANDING = "/";
export const SIGN_IN = "/signin";
export const SIGN_UP = "/signup";
export const SIGN_OUT = "/signout";
export const HOME = "/home";
export const ACCOUNT = "/account";
export const CHALLENGES = "/challenges";
export const ADMIN = "/admin";
export const PASSWORD_FORGET = "/pw-forget";
export const EVENTS = "/events";
export const ADDEVENT = "/addevent";
export const CHECKIN = "/checkin";
export const EVENTDETAILS = "/eventdetails/:eventId";
export const CHECKINDETAILS = "/checkin/:selectedEventId";
export const USERDETAILS = "/userdetails/:userid";
export const FILTERQUESTIONS = "/filterquestions";
export const FORM = "/form";
export const USERPROFILE = "/userprofile/:param"; //param can be either phone or email
export const TEAMMEMBER = "/teammembers";
export const ALLTEAMMEMBERS = "/all-teammembers";
export const CONSULTATIONS = "/consultations";